<template>
    <div class="c-timer d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
            <div
                v-if="consultationTime !== null"
                 class="mr-3">
                <span>{{ $locale.consultation_host }}予定時刻：</span>
                <span class="font-weight-bold">{{ consultationTime }}</span>
            </div>

            <div class="mr-3">
                <span>現在時刻：</span>
                <span
                    class="font-weight-bold"
                    :class="{ 'text-danger' : isPastWholeMinutes }">
                    {{ currentTime }}
                </span>

                <span class="small">（ </span>
                <span class="small" ><span v-if="userType === 'user' || userType === 'ex' ">医師の</span>入室時間：</span>
                <span
                    class="small font-weight-bold"
                    :class="{ 'text-danger' : isPastWholeMinutes }">
                    {{ currentElapsedMinutes }}分　
                </span>

                <span class="small"><span v-if="userType === 'user' || userType === 'ex' ">医師の</span>入室時間合計：</span>
                <span
                    class="small font-weight-bold"
                    :class="{ 'text-danger' : isPastWholeMinutes }">
                    {{ elapsedMinutesTotal }}分
                </span>
                <span class="small">）</span>
            </div>

            <div>
                <template v-if="sameTimeConsultations.length > 0">
                    <span class="small" style="position:relative;top:1px;">同じ{{ $locale.consultation_host }}予定時刻内の予約:</span>
                    <span class="small font-weight-bold" style="position:relative;top:1px;">{{ sameTimeConsultations.length }}</span><!--
                 --><span class="small" style="position:relative;top:1px;">件</span>
                    <button
                        class="btn btn-sm btn-yokumiru-orange ml-1"
                        @click="openDoctorConsultationsModal">
                        確認
                    </button>
                </template>

                <doctor-consultations-modal
                    v-if="doctor"
                    :doctor="doctor"
                    :consultations="sameTimeConsultations"
                    :searchable="false"
                    :paginate="false"
                    :card="false"
                    :filter-start-time="sameTimeConsultations.length > 0 ? sameTimeConsultations[0].start_time : null"
                    :filter-end-time="sameTimeConsultations.length > 0 ? sameTimeConsultations[0].end_time : null"
                    :filter-except="consultation.id">
                </doctor-consultations-modal>
            </div>
        </div>

        <div v-if="showConsultationStatus">
            <div class="d-flex align-items-center">
                <div class="text-muted">ステータス：&nbsp;</div>
                <div
                    class="c-indicator"
                    :class="detectStatusCSS">
                    <span>{{ detectStatusName }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FPSManager from '../../FPSManager'
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'
    import moment from "moment-timezone";

    const fps = new FPSManager({ fps: 1 })

    export default {
        props: {
            consultation: {
                type: Object,
                default: null,
            },
            showConsultationStatus: {
                type: Boolean,
                default: false,
            },
            userType: {
                type: String,
                required: true,
            },
            doctor: {
                type: Object,
                default: null,
            },
            timezone: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                current: null,
                currentJst: null,
                currentTime: null,
                wholeMinutes: 30,
                start: null,
                end: null,
                frame: null,
                count: 0,
                initElapsedMinutes: 0,     // 入室時点での経過時間
                currentElapsedMinutes: 0,  // 入室してからの経過時間
                elapsedMinutesTotal: 0,    // 医師の入室時間合計
                sameTimeConsultations: [],
                canStartTimeEmitted: false,
                isPastEndTimeEmitted: false,
            };
        },

        created: function () {
            this.init()
            bus.$on('user-reservation-completed', this.fetchSameTimeConsultations)
        },

        beforeDestroy: function () {
            bus.$off('user-reservation-completed')
        },

        mounted: function () {
            // UI表示に1秒間影響を与えてしまうため、画面表示時に一度実行する
            this.elapse()
        },

        methods: {
            openDoctorConsultationsModal: function() {
                bus.$emit('open-modal-doctor-consultations', this.doctor, this.sameTimeConsultations)
            },

            /**
             * 初期化処理
             */
            init: function() {
                moment.locale('ja')

                this.start = YokumiruHelper.userTime( this.consultation.start_time, this.timezone )
                this.end = YokumiruHelper.userTime( this.consultation.end_time, this.timezone )
                this.wholeMinutes = this.end.diff( this.start, 'minutes' )

                this.initElapsedMinutes = this.consultation.elapsed_time
                this.elapsedMinutesTotal = this.consultation.elapsed_time

                this.countdown()
                this.fetchSameTimeConsultations()
            },

            /**
             * 同じ相談予定時刻内の予約一覧を取得
             */
            fetchSameTimeConsultations: function () {
                if (this.userType === 'doctor' && this.$locale.type !== 'consul') {
                    const endpoint = constants.doctor.consultations.endpoint.base
                    const query = `?start_time=${this.consultation.start_time}&end_time=${this.consultation.end_time}&except=${this.consultation.id}`

                    axios.get(`${endpoint}${query}`).then(({data}) => {
                        this.sameTimeConsultations = data.data.filter((d) => {
                            return d.id !== this.consultation.id
                        })
                    })
                }
            },

            /**
             * カウントダウン処理
             */
            countdown: function() {
                this.frame = requestAnimationFrame(this.countdown)
                fps.tick(this.elapse)
            },

            /**
             * 1秒経過時
             * 表示中の時刻と経過時間を更新
             */
            elapse: function() {
                this.current = YokumiruHelper.userTimeNow(this.timezone)
                this.currentJst = YokumiruHelper.jstTimeNow()

                this.currentTime = this.current.format('ah:mm')
                if (this.currentTime.includes('午前12')) {
                    this.currentTime = this.currentTime.replace('午前12', '午前0')
                }

                if (!this.canStartTimeEmitted && this.canStartTime) {
                    bus.$emit('can-start-time-elapsed')
                    this.canStartTimeEmitted = true
                }

                if (!this.isPastEndTimeEmitted && this.isPastEndTime) {
                    bus.$emit('is-past-end-time-elapsed')
                    this.isPastEndTimeEmitted = true
                }

                // 相談が開始されていない場合、入室時間関連の処理をスキップ
                if (!this.consultation.started_at) {
                    return;
                }

                this.count += 1

                if (this.count >= 60) {
                    this.count = 0
                    if (this.userType === 'doctor') {
                        axios.put(`${constants.doctor.consultations.endpoint.update_elapsed_time}/${this.consultation.id}`)
                            .then((data) => {
                                this.elapsedMinutesTotal = data.data.elapsed_time
                                this.currentElapsedMinutes = this.elapsedMinutesTotal - this.initElapsedMinutes
                            })
                    }
                    else if (this.userType === 'user') {
                        axios.get(`${constants.user.consultations.endpoint.get_elapsed_time}/${this.consultation.id}`)
                            .then((data) => {
                                this.elapsedMinutesTotal = data.data.elapsed_time
                                this.currentElapsedMinutes = this.elapsedMinutesTotal - this.initElapsedMinutes
                            })
                    }
                }
            },
        },

        computed: {
            /**
             * 診療予定時刻の表示
             * @return {string|null}
             */
            consultationTime: function () {
                if (!this.consultation.doctor_menu) {
                    return null
                }

                const start = this.start
                const end = this.start.clone().add(this.consultation.doctor_menu.consultation_minutes, 'minutes')
                const time = `${start.format('YYYY年M月D日 ah:mm')} - ${end.format('ah:mm')}`

                return time.includes('午前12') ? time.replaceAll('午前12', '午前0') : time
            },

            /**
             * 診療予定時間の超過判定
             * @return {boolean}
             */
            isPastWholeMinutes: function () {
                return this.elapsedMinutesTotal >= this.wholeMinutes
            },

            /**
             * 開始可能時刻判定
             * @return {boolean}
             */
            canStartTime: function () {
                if (this.currentJst === null) return false

                const start = moment.tz(this.consultation.start_time, 'Asia/Tokyo')
                    .subtract(this.$store.state.configs.consultation_enter_min_start, 'minutes')

                const end = moment.tz(this.consultation.end_time, 'Asia/Tokyo')

                return this.currentJst.isSameOrAfter(start) && this.currentJst.isBefore(end)
            },

            /**
             * 終了時刻超過判定
             * @return {boolean}
             */
            isPastEndTime: function () {
                if (this.currentJst === null) return false

                const end = moment.tz(this.consultation.end_time, 'Asia/Tokyo')

                return this.currentJst.isSameOrAfter(end)
            },

            /**
             * ステータス表記
             * @return {string}
             */
            detectStatusCSS: function () {
                if (!this.consultation) return ''

                const result = constants.consultations.all.find(status => {
                    return status.value === this.consultation.status
                })

                // 診療終了
                if (result.value === constants.consultations.finished) {
                    if (!this.consultation.medical_record ||
                        !this.consultation.medical_record.body ||
                        this.consultation.medical_record.body.length < 1) {
                        return 'c-indicator--yellow'
                    }
                }
                return result.css
            },

            /**
             * ステータス表記
             *
             * @return {string}
             */
            detectStatusName: function () {
                if (!this.consultation) return ''

                let result = constants.consultations.all.find(status => {
                    return status.value === this.consultation.status
                })

                if (this.$locale.type === 'consul') {
                    result.text = result.text.replace('診療', '相談')
                    result.text = result.text.replace('患者', '会員')
                }

                // キャンセル
                if (this.consultation.flg_cancel == 1) {
                    if (constants.consultations.cancelAll.includes(result.value)) {
                        return result.text
                    }
                    if (this.consultation.flg_cancel_by_doctor == 1) {
                        return 'キャンセル（医師）'
                    }
                    return this.$locale.type === 'consul' ? 'キャンセル（会員）' : 'キャンセル（患者）'
                }

                // その他
                return result.text
            },
        }
    }
</script>
